import { createContext, useContext, useState, ReactNode } from 'react';

interface NewsItem {
  _id: string;
  title: string;
  slug: string;
  excerpt?: string;
  description?: string;
  featuredImage?: string;
  image?: string;
  category?: {
    _id: string;
    name: string;
    slug: string;
  };
  categoryName?: string;
  createdAt?: string;
  [key: string]: any;
}

interface NewsContextType {
  featuredNews: NewsItem[];
  setFeaturedNews: (news: NewsItem[]) => void;
}

const NewsContext = createContext<NewsContextType>({
  featuredNews: [],
  setFeaturedNews: () => {}
});

export const useNews = () => {
  const context = useContext(NewsContext);
  return context;
};

interface NewsProviderProps {
  children: ReactNode;
}

export const NewsProvider = ({ children }: NewsProviderProps) => {
  const [featuredNews, setFeaturedNews] = useState<NewsItem[]>([]);

  return (
    <NewsContext.Provider value={{ featuredNews, setFeaturedNews }}>
      {children}
    </NewsContext.Provider>
  );
};
